module.exports = __webpack_public_path__ + "public/media/developer-vector1.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-vector1.png
// module id = ./images/services/developer-vector1.png
// module chunks = 0